module.exports = __webpack_public_path__ + "static/media/kitaya.d09a1b84.jpg";